//
//
//
//
//
//
//
//
//
//

export default {
  name: "AppMain",
  computed: {
    // cachedViews() {
    //   return this.$store.state.tagsView.cachedViews;
    // },
    // key() {
    //   return this.$route.path;
    // }
  },
  mounted: function mounted() {
    this.$store.commit("app/SET_MAXSCROLLBAR", this.$refs.maxScrollbar.wrap);
  },
  methods: {}
};